/**
 *
 * @type {{priceEndpoint: string, getPrice: getPrice}}
 */
var Store = {

	priceEndpoint: '/' + Util.getLang() + '/?eID=price_v2',

	/**
	 * Retrieves a price by master sku
	 *
	 * @param string sku
	 * @param function callback
	 */
	getPrice: function (sku, callback) {
		var key = Store.getCacheKey(sku);
		if (sessionStorage.getItem(key)) {
			var data = sessionStorage.getItem(key);
			Store.readyCallback(callback, jQuery.parseJSON(data));
		} else {
			jQuery.ajax({
				dataType: 'json',
				url: Store.priceEndpoint,
				data: {sku: sku},
				success: function (data) {
					try {
						if (Util.isSessionStorageEnabled()) {
							sessionStorage.setItem(key, JSON.stringify(data));
							$(document).trigger('price.ajax.ready');
						}
					} catch (e) {
						console.log('session-store', e);
					}
					Store.readyCallback(callback, data);
				}
			});
		}
	},

	readyCallback: function (callback, data) {
		$(document).trigger('price.ready');
		callback(data);
	},

	getCacheKey: function (sku) {
		return 'price-' + sku + Util.getLang() + Util.getCountry() + Util.getTypoSessionId() + Util.getCacheKey();
	},

	isCached: function (sku) {
		var key = Store.getCacheKey(sku);
		return sessionStorage.getItem(key);
	}

};
